import React, { useState } from "react";
import { useProductsContext, useAuthContext } from "../../contexts";
import { useNavigate,useLocation } from "react-router";
import commonObj from '../../../utils/Common';
import { notify } from "../../../utils/utils";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
const CategoryCard = ({
  category: { id, categoryName, categoryDescription, categoryImage },
  url: url, type="product"
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { applyFilters } = useProductsContext();
  const { token,userInfo } = useAuthContext();
  const [showCategory, setShowCategory] = useState(true);
  /*const clickHandlerOLD = () => {
    if (!token) {
      navigate("/login", { state: { from: location.pathname } });
      notify("warn", commonObj.getLabel('Please_Login_to_continue'));
    } else {
      if (id==userInfo?.categoryId) {
        navigate("/products/"+id, { state: { from: "category", categoryName:categoryName } });
      } else {
        notify("warn", commonObj.getLabel('You_not_register_for_category'));
      }
    }
  };*/
  const clickHandler = () => {
    let url = (type==="transportations") ? "/transportations/" : "/products/";
    if(id===41) id = id+'?mining=1'
    navigate(url+id, { state: { from: "category", categoryName:categoryName } });
  };
  return (
    <section
      className=" flex flex-col items-center rounded-xl  relative overflow-hidden cursor-pointer gap-3  categoryContainer maincat-name"
      onClick={clickHandler}
    >
      <div className="item_image_box flex flex-col overflow-hidden w-full h-full">
      <img
        src={url+categoryImage}
        alt={categoryName}
        className="rounded-xl h-full w-full object-cover"
      />
      <div
        className="
             flex flex-col w-full h-full justify-end items-start
            transition-all delay-75 absolute left-0 right-0 bottom-0 top-0 card_overlay rounded-xl"
      >
        <h1 className="text-2xl   capitalize text-[--theme-color]  p-6 break-all">
          <FaRegArrowAltCircleRight className="mb-2" />
          {categoryName}
        </h1>
      </div>
      </div>
    </section>
  );
};

export default CategoryCard;
